import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';

// Brand-aligned theme — same red/black/white as the misstwice.vegas microsite
export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'sovLight',
    themes: {
      sovLight: {
        dark: false,
        colors: {
          primary: '#E4002B',
          secondary: '#111111',
          background: '#FAFAFA',
          surface: '#FFFFFF',
          error: '#E4002B',
          success: '#1A8A3A',
          warning: '#E89C1A',
        },
      },
    },
  },
  defaults: {
    VBtn: { variant: 'flat', rounded: 'md' },
    VTextField: { variant: 'outlined', density: 'comfortable' },
    VSelect: { variant: 'outlined', density: 'comfortable' },
    VCard: { rounded: 'lg' },
  },
});
